var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yandex-maps-page"},[_c('yandex-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"coords":_vm.coords,"zoom":10,"controls":['zoomControl', 'geolocationControl','fullscreenControl']},on:{"click":_vm.onClick}},[_c('ymap-marker',{attrs:{"coords":_vm.coords,"marker-id":"ymap-markey-id"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }